<template>
  <div class="restaurant-card">
    <div class="restaurant-card__media">
      <AtomImage class="aspect-square" :src="useCloudinaryImage(restaurant.cover, 200, 200)" :alt="restaurant.name" />
    </div>
    <div class="restaurant-card__info">
      <div class="restaurant-card__heading">{{ restaurant.name }}</div>
      <div class="restaurant-card__meta">
        <AtomRestaurantLocation 
          :name="restaurant.address" 
          :address="restaurant.city"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  restaurant: {
    type: Object,
    default: () => {}
  },
  position: {
    type: Number,
    default: 0
  }
})
</script>

<style lang="scss" scoped>
.restaurant-card {
  @apply @container;
  @apply relative flex items-center gap-3 bg-mist rounded overflow-hidden;

  &__media {
    @apply w-full bg-black relative;
    // @apply rounded overflow-hidden;
    @apply w-24;
  }

  &__info {
    @apply flex-1;
  }

  &__info {
    @apply grid gap-0.5 @xs:gap-1;
  }
  
  &__heading {
    @apply font-heading font-medium text-lg @xs:text-xl;
  }

  &__meta {
    @apply text-sm;
  }
}
</style>
